// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-input[data-v-e4fa6446] {\n  width: 300px;\n}\n.tree-wrapper[data-v-e4fa6446] {\n  height: 600px;\n  overflow-y: auto;\n}", ""]);
// Exports
module.exports = exports;
